<template>
  <div>
    <check-base-layout
      :pagetitle="pagetitle"
      :check-info-data="checkFrom.purchaseBaseApprovalsVo"
    >
      <template>
        <check-module :title="`合同总览`">
          <compart-module :isCustomer="false" :compart-data="checkFrom.purchaseContractBasesVo"></compart-module>
        </check-module>
        <check-module
          :title="`退货价值`"
          :is-table="true"
        >
          <info-table
            :field-arr="returnPriceField"
            :table-data="[checkFrom]"
            :to-fixed-format="['retreatProductTotal','confiscateTotal']"
            :percent-format="['confiscatedRatio']"
          ></info-table>
        </check-module>
        <check-module
          :title="`退货清单`"
          :is-table="true"
        >
          <info-table
            :field-arr="shipField"
            :table-height="`300px`"
            :table-data="checkFrom.purchaseLaunchRetreatVoList"
            :to-fixed-format="['purchasePrice','discountPrice','actualPrice','confiscateMoney']"
            :percent-format="['confiscatedRatio']"
          ></info-table>
        </check-module>
      </template>
      <template v-slot:checkFooter>
        <slot name="footer">
          <check-module :title="`审批信息`">
            <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVo"></check-info-module>
          </check-module>
        </slot>
      </template>
    </check-base-layout>
    <in-prouct-serial-code-dialog
      ref="inProuctSerialCodeRefs"
      :disabled="true"
      :title="`查看序列号`"
    >
      <template #operating>
<div></div>
      </template>
      <template #footer>
        <el-button type="primary" @click="$refs.inProuctSerialCodeRefs.disableDialog = false">确定</el-button>
        <el-button @click="$refs.inProuctSerialCodeRefs.disableDialog = false">取消</el-button>
      </template>
    </in-prouct-serial-code-dialog>
  </div>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import InProuctSerialCodeDialog from '@/views/purchase/purchaseManage/dialog/inProuctSerialCodeDialog'
let _t
export default {
  name: 'poreturnCheck',
  components: { InProuctSerialCodeDialog },
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '采购退货审批'
    }
  },
  data () {
    _t = this
    return {
      shipField: [
        {
          label: '品牌',
          name: 'brandName'
        },
        {
          label: '型号',
          name: 'proModel'
        },
        {
          label: '订货号',
          name: 'proOrderNum'
        },
        {
          label: '单位',
          name: 'proUnit'
        },
        {
          label: '数量',
          name: 'pccCount'
        },
        {
          label: '类型',
          name: 'proExType'
        },
        {
          label: '采购单价',
          name: 'purchasePrice'
        },
        {
          label: '抵扣金额',
          name: 'discountPrice'
        },
        {
          label: '实付单价',
          name: 'actualPrice'
        },
        {
          label: '发货状态',
          name: 'deliverState'
        },
        {
          label: '收票状态',
          name: 'invoiceState'
        },
        {
          label: '产品序列号',
          name: '查看',
          type: 'handler',
          clickNode(item, row) {
            // const val = row.serialCode.split(';') || []
            _t.$refs.inProuctSerialCodeRefs.onInitial(row, 0, 1, true)
          }
        },
        {
          label: '罚没单价',
          name: 'confiscateMoney'
        },
        {
          label: '罚没比例',
          name: 'confiscatedRatio'
        }
      ],
      returnPriceField: [
        {
          label: '退货产品销售总额',
          name: 'retreatProductTotal'
        },
        {
          label: '罚没总额',
          name: 'confiscateTotal'
        },
        {
          label: '罚没比例',
          name: 'confiscatedRatio'
        }
      ]
    }
  },
  mounted () {
    const { snaId } = this
    checkApi.getPoreturnCheckInfo({
      snaId
    }).then(res => {
      if (isSuccess(res)) {
        this.checkFrom = res.data?.obj ?? {}
        this.$emit('update:data', res.data?.obj ?? {})
      }
    })
  }
}
</script>

<style scoped></style>
